import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const QUICK_TAGS = [
  { id: "gratidao", label: "Gratidão", emoji: "🙏" },
  { id: "focado", label: "Focado(a)", emoji: "🎯" },
  { id: "confiante", label: "Confiante", emoji: "💪" },
  { id: "sobrecarga", label: "Sobrecarga", emoji: "🌀" },
  { id: "inspirado", label: "Inspirado(a)", emoji: "✨" },
  { id: "calmo", label: "Calmo(a)", emoji: "☕" },
  { id: "sensivel", label: "Sensível", emoji: "🌸" },
  { id: "orgulhoso", label: "Orgulhoso(a)", emoji: "🏆" },
];

export default function Diary() {
  const navigate = useNavigate();

  // Estados dos Sliders (0 a 100, valor inicial 50 = Neutro)
  const [moodValue, setMoodValue] = useState(50);
  const [energyValue, setEnergyValue] = useState(50);
  const [calmValue, setCalmValue] = useState(50);

  const [selectedTags, setSelectedTags] = useState([]);
  const [note, setNote] = useState("");
  const [saved, setSaved] = useState(false);
  const [history, setHistory] = useState([]);

  // Carregar histórico local
  useEffect(() => {
    try {
      const stored = localStorage.getItem("mariam_diary_logs");
      if (stored) {
        setHistory(JSON.parse(stored));
      }
    } catch {
      // sem ação
    }
  }, []);

  // Helper para interpretar Humor
  const getMoodInfo = (val) => {
    if (val <= 20) return { label: "Muito Para Baixo", emoji: "😔", color: "text-red-600", bg: "bg-red-50 border-red-200" };
    if (val <= 40) return { label: "Um Pouco Triste", emoji: "🙁", color: "text-amber-700", bg: "bg-amber-50 border-amber-200" };
    if (val <= 60) return { label: "Neutro / Normal", emoji: "😐", color: "text-[#6C54D8]", bg: "bg-[#ECE7FA] border-[#ECE7FA]" };
    if (val <= 80) return { label: "Bem / Animado(a)", emoji: "😊", color: "text-emerald-700", bg: "bg-[#CBF1DB]/60 border-emerald-200" };
    return { label: "Muito Feliz / Radiante", emoji: "🌟", color: "text-emerald-800", bg: "bg-[#CBF1DB] border-emerald-300" };
  };

  // Helper para interpretar Energia
  const getEnergyInfo = (val) => {
    if (val <= 20) return { label: "Esgotado(a)", emoji: "😴" };
    if (val <= 40) return { label: "Cansado(a)", emoji: "🔋" };
    if (val <= 60) return { label: "Disposição Normal", emoji: "⚖️" };
    if (val <= 80) return { label: "Energizado(a)", emoji: "⚡" };
    return { label: "Super Motivado(a)", emoji: "🚀" };
  };

  // Helper para interpretar Paz x Ansiedade
  const getCalmInfo = (val) => {
    if (val <= 20) return { label: "Muito Ansioso(a)", emoji: "🌪️" };
    if (val <= 40) return { label: "Agitado(a)", emoji: "😰" };
    if (val <= 60) return { label: "Equilibrado(a)", emoji: "🍃" };
    if (val <= 80) return { label: "Tranquilo(a)", emoji: "🧘" };
    return { label: "Totalmente em Paz", emoji: "🕊️" };
  };

  const moodInfo = getMoodInfo(moodValue);
  const energyInfo = getEnergyInfo(energyValue);
  const calmInfo = getCalmInfo(calmValue);

  const toggleTag = (tagLabel) => {
    setSelectedTags((prev) =>
      prev.includes(tagLabel)
        ? prev.filter((t) => t !== tagLabel)
        : [...prev, tagLabel]
    );
  };

  const handleSave = () => {
    const entry = {
      id: Date.now(),
      date: new Date().toISOString(),
      mood: { value: moodValue, label: moodInfo.label, emoji: moodInfo.emoji },
      energy: { value: energyValue, label: energyInfo.label, emoji: energyInfo.emoji },
      calm: { value: calmValue, label: calmInfo.label, emoji: calmInfo.emoji },
      tags: selectedTags,
      note: note.trim(),
    };

    const newHistory = [entry, ...history].slice(0, 20);
    setHistory(newHistory);

    try {
      localStorage.setItem("mariam_diary_logs", JSON.stringify(newHistory));
    } catch {
      // sem ação
    }

    setSaved(true);
    setTimeout(() => {
      setSaved(false);
    }, 4000);
  };

  return (
    <div className="space-y-4">
      {/* BOTÃO DE VOLTAR */}
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 text-xs font-bold text-[#6C54D8] hover:text-[#24152F] transition-colors py-1 group cursor-pointer"
      >
        <svg className="w-4 h-4 transition-transform group-hover:-translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
        </svg>
        Voltar
      </button>

      {/* HERO HEADER LITI */}
      <div className="liti-card p-5 shadow-sm border border-[#ECE7FA] space-y-2">
        <div className="flex items-center gap-3.5">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#6C54D8] text-white text-2xl shadow-xs font-bold">
            📖
          </div>
          <div>
            <h1 className="text-xl font-bold text-[#24152F] font-serif tracking-tight">
              Diário das Emoções
            </h1>
            <p className="text-xs font-medium text-[#6D6680] mt-0.5">
              Como você está se sentindo neste momento?
            </p>
          </div>
        </div>
      </div>

      {/* FEEDBACK DE SUCESSO NO TOPO */}
      {saved && (
        <div className="rounded-2xl border border-[#CBF1DB] bg-[#CBF1DB] p-4 text-center text-xs font-bold text-emerald-900 shadow-md animate-in fade-in zoom-in-95 duration-200 flex items-center justify-center gap-2">
          <span className="text-lg">💜</span>
          <span>Registro salvo com sucesso! É um passo valioso para cuidar de você.</span>
        </div>
      )}

      {/* CONTÊINER DOS SLIDERS INTERATIVOS */}
      <div className="liti-card p-5 shadow-sm border border-[#ECE7FA] space-y-6">
        <div className="border-b border-[#ECE7FA] pb-3">
          <h2 className="text-sm font-bold text-[#24152F] font-serif">
            Espectro Emocional
          </h2>
          <p className="text-xs font-medium text-[#6D6680] mt-0.5">
            Arraste as barras abaixo do polo negativo para o positivo.
          </p>
        </div>

        {/* SLIDER 1: HUMOR GERAL */}
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <label className="text-xs font-bold uppercase tracking-wider text-[#6D6680]">
              1. Humor Geral
            </label>
            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold border shadow-xs transition-all ${moodInfo.bg}`}>
              <span className="text-sm">{moodInfo.emoji}</span>
              <span>{moodInfo.label}</span>
            </span>
          </div>

          <div className="pt-1">
            <input
              type="range"
              min="0"
              max="100"
              value={moodValue}
              onChange={(e) => setMoodValue(Number(e.target.value))}
              className="w-full h-3 rounded-full appearance-none bg-gradient-to-r from-red-200 via-amber-200 to-[#CBF1DB] cursor-pointer accent-[#6C54D8] shadow-inner"
            />
          </div>

          {/* EXTREMIDADES COM EMOJIS */}
          <div className="flex justify-between items-center text-[11px] font-semibold text-[#6D6680] pt-0.5">
            <span className="flex items-center gap-1">
              <span>😔</span> Triste
            </span>
            <span className="flex items-center gap-1">
              <span>😐</span> Neutro
            </span>
            <span className="flex items-center gap-1">
              <span>🌟</span> Radiante
            </span>
          </div>
        </div>

        {/* SLIDER 2: ENERGIA & DISPOSIÇÃO */}
        <div className="space-y-2 pt-2 border-t border-[#ECE7FA]">
          <div className="flex items-center justify-between">
            <label className="text-xs font-bold uppercase tracking-wider text-[#6D6680]">
              2. Energia & Disposição
            </label>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-[#ECE7FA] text-[#6C54D8] border border-[#ECE7FA]">
              <span className="text-sm">{energyInfo.emoji}</span>
              <span>{energyInfo.label}</span>
            </span>
          </div>

          <div className="pt-1">
            <input
              type="range"
              min="0"
              max="100"
              value={energyValue}
              onChange={(e) => setEnergyValue(Number(e.target.value))}
              className="w-full h-3 rounded-full appearance-none bg-gradient-to-r from-red-200 via-amber-200 to-[#CBF1DB] cursor-pointer accent-[#6C54D8] shadow-inner"
            />
          </div>

          {/* EXTREMIDADES COM EMOJIS */}
          <div className="flex justify-between items-center text-[11px] font-semibold text-[#6D6680] pt-0.5">
            <span className="flex items-center gap-1">
              <span>😴</span> Esgotado
            </span>
            <span className="flex items-center gap-1">
              <span>⚖️</span> Normal
            </span>
            <span className="flex items-center gap-1">
              <span>🚀</span> Motivado
            </span>
          </div>
        </div>

        {/* SLIDER 3: PAZ X ANSIEDADE */}
        <div className="space-y-2 pt-2 border-t border-[#ECE7FA]">
          <div className="flex items-center justify-between">
            <label className="text-xs font-bold uppercase tracking-wider text-[#6D6680]">
              3. Nível de Calma & Paz
            </label>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-[#ECE7FA] text-[#6C54D8] border border-[#ECE7FA]">
              <span className="text-sm">{calmInfo.emoji}</span>
              <span>{calmInfo.label}</span>
            </span>
          </div>

          <div className="pt-1">
            <input
              type="range"
              min="0"
              max="100"
              value={calmValue}
              onChange={(e) => setCalmValue(Number(e.target.value))}
              className="w-full h-3 rounded-full appearance-none bg-gradient-to-r from-red-200 via-amber-200 to-[#CBF1DB] cursor-pointer accent-[#6C54D8] shadow-inner"
            />
          </div>

          {/* EXTREMIDADES COM EMOJIS */}
          <div className="flex justify-between items-center text-[11px] font-semibold text-[#6D6680] pt-0.5">
            <span className="flex items-center gap-1">
              <span>🌪️</span> Ansioso
            </span>
            <span className="flex items-center gap-1">
              <span>🍃</span> Equilibrado
            </span>
            <span className="flex items-center gap-1">
              <span>🕊️</span> Em Paz
            </span>
          </div>
        </div>
      </div>

      {/* TAGS RÁPIDAS DE SENTIMENTOS */}
      <div className="liti-card p-5 shadow-sm border border-[#ECE7FA] space-y-3">
        <h3 className="text-sm font-bold text-[#24152F] font-serif">
          Sentimentos Complementares (opcional)
        </h3>

        <div className="flex flex-wrap gap-2">
          {QUICK_TAGS.map((tag) => {
            const isSelected = selectedTags.includes(tag.label);
            return (
              <button
                key={tag.id}
                type="button"
                onClick={() => toggleTag(tag.label)}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-bold transition-all duration-200 cursor-pointer ${
                  isSelected
                    ? "bg-[#6C54D8] text-white shadow-xs scale-105"
                    : "bg-[#FAFAFC] text-[#24152F] border border-[#ECE7FA] hover:bg-[#ECE7FA]"
                }`}
              >
                <span>{tag.emoji}</span>
                <span>{tag.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* DESABAFO / NOTA */}
      <div className="liti-card p-5 shadow-sm border border-[#ECE7FA] space-y-2">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-bold text-[#24152F] font-serif">
            Quer desabafar algo por escrito?
          </h3>
          <span className="text-[10px] font-bold text-[#6D6680]">
            {note.length}/500
          </span>
        </div>

        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value.slice(0, 500))}
          placeholder="Escreva livremente o que está na sua mente hoje…"
          className="input-base w-full min-h-[90px] p-3.5 text-xs font-medium text-[#24152F] placeholder-gray-400 outline-none resize-none"
        />
      </div>

      {/* FEEDBACK ANCORADO AO BOTÃO SALVAR (TOAST INLINE) */}
      {saved && (
        <div className="rounded-2xl border border-[#CBF1DB] bg-[#CBF1DB] p-3.5 text-center text-xs font-bold text-emerald-900 shadow-md animate-in fade-in slide-in-from-bottom-2 duration-200 flex items-center justify-center gap-2">
          <span className="text-base">✓</span>
          <span>Registro salvo com sucesso!</span>
        </div>
      )}

      {/* BOTÃO SALVAR */}
      <button
        type="button"
        onClick={handleSave}
        className="btn-primary w-full h-12 text-xs font-bold uppercase tracking-wider shadow-md flex items-center justify-center gap-2 cursor-pointer"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
        </svg>
        Salvar Registro Emocional
      </button>

      {/* HISTÓRICO RECENTE */}
      {history.length > 0 && (
        <div className="liti-card p-5 shadow-sm border border-[#ECE7FA] space-y-3 pt-2">
          <h3 className="text-sm font-bold text-[#24152F] font-serif">
            Registros Recentes
          </h3>

          <div className="space-y-2.5">
            {history.slice(0, 5).map((item) => (
              <div key={item.id} className="rounded-2xl bg-[#ECE7FA]/60 border border-[#ECE7FA] p-3.5 space-y-1.5">
                <div className="flex items-center justify-between text-xs font-bold">
                  <span className="text-[#6C54D8] flex items-center gap-1.5">
                    <span className="text-base">{item.mood?.emoji}</span>
                    <span>{item.mood?.label}</span>
                  </span>
                  <span className="text-[10px] text-[#6D6680] font-medium">
                    {new Date(item.date).toLocaleDateString("pt-BR", {
                      day: "2-digit",
                      month: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>

                <div className="flex flex-wrap gap-1">
                  {item.tags?.map((tag, idx) => (
                    <span key={idx} className="rounded-full bg-white px-2.5 py-0.5 text-[10px] font-bold text-[#6C54D8] border border-[#ECE7FA]">
                      {tag}
                    </span>
                  ))}
                </div>

                {item.note && (
                  <p className="text-xs text-[#6D6680] font-medium italic pt-1 border-t border-[#ECE7FA]">
                    "{item.note}"
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}